export default "__VITE_ASSET__CDf2GL9b__"